import { auth } from "../firebase";
import ENV from "../env";
async function request(path, body, authenticated = false) {
  const headers = { "Content-Type": "application/json" };
  if (authenticated) {
    if (!auth.currentUser) throw new Error("Authentication required");
    headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
  }
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/public-checkout/${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  const result = await response.json();
  if (!response.ok)
    throw Object.assign(new Error(result.error || "Checkout verification failed"), {
      status: response.status,
    });
  return result;
}
export const getPublicCheckoutStatus = (body) => request("status", body);
export const resolvePublicCheckout = (body) => request("resolve", body, true);
